import {Alert, Modal} from '@mantine/core'
import {ChangePasswordForm} from './ChangePasswordForm'
import {delay, doSafe} from 'shared/promise'
import {match} from 'ts-pattern'
import {SignIn} from './SignIn'
import {usePortal} from 'components/portal/portal'
import {HiExclamationCircle} from 'react-icons/hi'

export const AuthModal = ({
  showAction,
  description: descriptionRaw,
  onClose
}: {
  showAction?: 'recovery' | 'anon-signup' | undefined
  description?: string
  onClose: () => void
}) => {
  const {portalRefetch} = usePortal()
  return (
    <Modal
      opened={showAction != null}
      onClose={onClose}
      size='auto'
      closeOnClickOutside={false}
      title={match(showAction)
        .with('recovery', () => 'Set a password')
        .with('anon-signup', () => 'Sign in') // we call it sign in, but underneath it's sign up
        .otherwise(() => (
          <></>
        ))}>
      <div className='w-[calc(min(40em,100vw))] flex flex-col gap-4'>
        {doSafe(
          descriptionRaw ??
            match(showAction)
              .with('anon-signup', () => (
                <div>
                  You are using the app as a participant (temporary, anonymous user). Sign in so that you can come back
                  later on any device and own the forecasts and comments you create.
                  <Alert
                    className='mt-2'
                    color='orange'
                    title={
                      <span>
                        <HiExclamationCircle className='icon-text' /> After signing in, an admin of this workspace will
                        need to approve your request for access as a user.
                      </span>
                    }></Alert>
                </div>
              ))
              .otherwise(() => undefined),
          d => (
            <div className='text-gray-600'>{d}</div>
          )
        )}
        {match(showAction)
          .with('recovery', () => <ChangePasswordForm close={onClose} buttonLabel='Set password' />)
          .with('anon-signup', () => (
            <SignIn
              variant='form'
              actionDesc='link to an email'
              initialMode='anon-signup'
              hideModeChange
              onSignIn={{
                desc: 'Signed in. Refreshing the app',
                action: () =>
                  portalRefetch()
                    .then(() => delay(1000))
                    .then(() => onClose())
              }}
            />
          ))
          .otherwise(() => (
            <></>
          ))}
      </div>
    </Modal>
  )
}
